// extracted by mini-css-extract-plugin
export default {"groupChat":"GroupChat_groupChat__z0sJs","close":"GroupChat_close__-5-LY","messagesList":"GroupChat_messagesList__qEgXm"};